import { makeid } from 'utils/helpers/makeid';

import { CONSENT_ATTESTATION_SCRIPT } from '../scripts/constants';

import type { TFormItem } from '../../types';

export const step3Config: TFormItem[] = [
  {
    key: makeid(10),
    name: 'consent',
    type: 'radio',
    title: (
      <p>
        #3 Consent / Communication Authorization Verification
        <br />
        <strong style={{ fontSize: 16 }}>Who did you speak with?</strong>
      </p>
    ),
    required: true,
    options: [
      { key: makeid(10), label: 'Patient', value: 'patient' },
      {
        key: makeid(10),
        label: "Representative (manages patient's healthcare communications)",
        value: 'representative',
        hideSubitemsIfParentNotSelected: true,
        subItems: [
          {
            key: makeid(10),
            name: 'representativeName',
            type: 'input',
            title: <p>Representative Name</p>,
            required: true,
          },
          {
            key: makeid(10),
            name: 'representativeRelationship',
            type: 'input',
            title: <p>Relationship to Patient</p>,
            required: true,
          },
          {
            key: makeid(10),
            name: 'representativeAttestation',
            type: 'radio',
            title: <p>Attestation Obtained?</p>,
            required: true,
            options: [
              { key: makeid(10), label: 'Yes', value: 'yes' },
              { key: makeid(10), label: 'No', value: 'no' },
            ],
          },
          {
            key: makeid(10),
            name: 'attestationScriptInfo',
            type: 'info',
            html: (
              <p style={{ fontStyle: 'italic' }}>
                <strong>Script for clinical team member to read aloud:</strong>
                <br /> &ldquo;
                {CONSENT_ATTESTATION_SCRIPT}&rdquo;
              </p>
            ),
          },
        ],
      },
      {
        key: makeid(10),
        label: 'Unable to Verify Identity/Authorization',
        value: 'unable-to-verify',
      },
    ],
  },
];
